<template>
  <input ref="inputRef" type="text" @focus="$emit('focus', $event)" @blur="$emit('blur', $event)" />
</template>

<script>
import { watch } from '@vue/composition-api';
import { useCurrencyInput } from 'vue-currency-input';

export default {
  props: {
    value: Number,
    options: Object,
  },
  setup(props) {
    const { inputRef, setOptions, setValue } = useCurrencyInput(props.options);

    watch(
      () => props.value,
      value => {
        setValue(value);
      }
    );

    watch(
      () => props.options,
      options => {
        setOptions(options);
      }
    );

    return { inputRef };
  },
};
</script>
